import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import {CacheService} from '../cache.service';
import {AppService} from '../app.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import {RedirectionService} from '../services/redirection/redirection.service';
import { ConnectionService } from 'ng-connection-service';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MatLegacyDialogContainer as MatDialogContainer } from '@angular/material/legacy-dialog';
import {CommonDialogComponent} from '../common-dialog/common-dialog.component';
import {
  captureIqSetupFromWindow,
  maybeClearStaleIqSetupContext,
} from '../shared/helpers/iq-setup-context.helper';


@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit, OnDestroy {
  uncommonBaseWord: string = this.appService.getUncommonBaseWord();
  dialogComponent: MatDialogRef<any>;
  dialogActive = false;
  isInternetConnected = true;
  private routerEventsSubscription: Subscription;


  constructor(private appService: AppService, private cacheService: CacheService, private route: ActivatedRoute, private router: Router,
    private connectionService: ConnectionService, private dialog: MatDialog,
    private redirectService: RedirectionService) {

    if (!this.cacheService.hasValidAuthKey()) {
      this.redirectService.redirectToLogin();
    }

    this.isInternetConnected = navigator.onLine;
    if (!this.isInternetConnected) {
      this.notConnectedProceed(this.isInternetConnected);
    }

    this.connectionService.monitor().subscribe(isConnected => {
      this.isInternetConnected = isConnected;
      if (isConnected && this.dialogActive) {
      //  this.dialogComponent.close();
        this.notConnectedProceed(isConnected);
        this.dialogActive = false;
      } else if (!isConnected) {
        this.notConnectedProceed(isConnected);
      }
    });

    // this.router.events.subscribe((val) => {
    //   if (val instanceof ActivationEnd && !this.isInternetConnected && !this.dialogActive) {
    //     console.log('route activation ended');
    //     this.notConnectedProceed();
    //   }
    // });
   }

  ngOnInit() {
    captureIqSetupFromWindow();
    this.routerEventsSubscription = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        maybeClearStaleIqSetupContext(
          event.urlAfterRedirects,
          this.appService.getBaseWord(),
        );
      });
  }

  ngOnDestroy() {
    if (this.routerEventsSubscription) {
      this.routerEventsSubscription.unsubscribe();
    }
  }

  notConnectedProceed(isConnected) {
    // this.dialogComponent = this.dialog.open(CommonDialogComponent, {
    //   data: {
    //     title: 'Alert!',
    //     content: 'Please check your internet connection',
    //     image: '',
    //     buttons: []
    //   },
    //   disableClose: true
    // });
     this.dialogActive = true;
    this.appService.getNoConnectionEvent().next(!isConnected);
  }

}
